<template>
  <div class="data-visualization" :class="{ 'fullscreen': isFullscreen }">
    <!-- 可视化大屏页面 -->
    <div class="screen-container">
      <!-- 顶部标题区域 -->
      <div class="screen-header">
        <!-- <dv-decoration-1 class="decoration-1" /> -->
        <div class="title-container">
          <dv-decoration-6 class="title-decoration" />
          <div class="title-text">防 撞 预 警 一 张 图</div>
          <dv-decoration-6 class="title-decoration reverse" />
        </div>
        <!-- <dv-decoration-1 class="decoration-1 reverse" /> -->

        <!-- 桥梁名称显示（左上角） -->
        <div class="bridge-name">{{ bridgeName }}</div>

        <!-- 当前时间显示（右上角） -->
        <div class="current-time">{{ currentTime }}</div>

        <!-- 全屏控制按钮 -->
        <div class="fullscreen-control" style="display: none;">
          <el-button
            type="primary"
            size="small"
            :icon="isFullscreen ? 'el-icon-close' : 'el-icon-full-screen'"
            @click="toggleFullscreen"
            class="fullscreen-btn">
            <!-- {{ isFullscreen ? '退出全屏' : '全屏显示' }} -->
          </el-button>
        </div>
      </div>

      <!-- 主体内容区域 -->
      <div class="screen-body">
        <div class="dashboard-layout">
          <div class="panel-left">
            <div class="data-card hover-pop-card">
              <div class="data-card-header">今日预警概览</div>
              <div class="data-card-content" v-loading="loading.alertOverview">
                <div class="today-overview">
                  <div class="overview-number">
                    <span class="label">船舶流量</span>
                    <span class="value">{{ todayTraffic.totalCount }}</span>
                  </div>
                  <div class="overview-number">
                    <span class="label">预警总数</span>
                    <span class="value">{{ todayAlertCount }}</span>
                  </div>
                  <div class="overview-number">
                    <span class="label">预警率</span>
                    <span class="value">{{ todayAlertRate }}</span>
                  </div>
                  <div class="overview-sub">峰值时段：{{ peakAlertTimeLabel }}</div>
                </div>
              </div>
            </div>

            <div class="data-card">
              <div class="data-card-header">告警类型分布</div>
              <div class="data-card-content">
                <div class="chart-container-mini" id="alert-type-chart" v-loading="loading.alertType"></div>
              </div>
            </div>

            <div class="data-card">
              <div class="data-card-header">船舶类型分布</div>
              <div class="data-card-content">
                <div class="chart-container-mini" id="vessel-type-chart" v-loading="loading.shipStats"></div>
              </div>
            </div>
          </div>

          <div class="panel-center">
            <div class="data-card center-kpi-card">
              <div class="data-card-content">
                <div class="kpi-banner-title">今日预警趋势</div>
                <div class="kpi-main-layout">
                  <div class="kpi-left-metrics">
                    <div class="metric-row">
                      <span class="metric-label">船舶流量</span>
                      <div class="metric-digits">
                        <span
                          v-for="(digit, index) in String(todayTraffic.totalCount || 0).padStart(6, '0').split('')"
                          :key="`flow-${index}`"
                          class="metric-digit"
                        >{{ digit }}</span>
                      </div>
                      <!-- <span class="metric-sub">预警率 {{ todayAlertRate }}</span> -->
                    </div>
                    <div class="metric-row">
                      <span class="metric-label">预警总数</span>
                      <div class="metric-digits">
                        <span
                          v-for="(digit, index) in String(todayAlertCount || 0).padStart(6, '0').split('')"
                          :key="`alert-${index}`"
                          class="metric-digit"
                        >{{ digit }}</span>
                      </div>
                      <span class="metric-sub">昨日同比 {{ alertCompareRatio }}</span>
                    </div>
                  </div>
                  <div class="kpi-rate-panel">
                    <div class="kpi-rate-core"></div>
                    <div class="kpi-rate-meta">
                      <div class="kpi-rate-label">预警率</div>
                      <div class="kpi-rate-value">{{ todayAlertRate }}</div>
                      <div class="kpi-rate-sub">本年预警 {{ yearlyAlertCount }}</div>
                    </div>
                  </div>
                </div>
                <div class="kpi-type-row" v-loading="loading.alertOverview">
                  <div class="kpi-type-item">
                    <div class="kpi-type-icon"><i class="el-icon-guide"></i></div>
                    <div class="kpi-type-info">
                      <div class="kpi-type-name">偏航预警</div>
                      <div class="kpi-type-count">{{ getTodayTypeCount('偏航') }} 次</div>
                    </div>
                  </div>
                  <div class="kpi-type-item">
                    <div class="kpi-type-icon"><i class="el-icon-odometer"></i></div>
                    <div class="kpi-type-info">
                      <div class="kpi-type-name">超速预警</div>
                      <div class="kpi-type-count">{{ getTodayTypeCount('超速') }} 次</div>
                    </div>
                  </div>
                  <div class="kpi-type-item">
                    <div class="kpi-type-icon"><i class="el-icon-warning-outline"></i></div>
                    <div class="kpi-type-info">
                      <div class="kpi-type-name">超高预警</div>
                      <div class="kpi-type-count">{{ getTodayTypeCount('超高') }} 次</div>
                    </div>
                  </div>
                  <div class="kpi-type-item">
                    <div class="kpi-type-icon"><i class="el-icon-time"></i></div>
                    <div class="kpi-type-info">
                      <div class="kpi-type-name">滞留预警</div>
                      <div class="kpi-type-count">{{ getTodayTypeCount('滞留') }} 次</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="data-card trend-tab-card">
              <div class="trend-tab-header">
                <button
                  type="button"
                  class="trend-tab-btn"
                  :class="{ active: activeTrendTab === 'trafficTrend' }"
                  @click="handleTrendTabChange('trafficTrend')">
                  24小时流量趋势
                </button>
                <span class="trend-tab-separator">|</span>
                <button
                  type="button"
                  class="trend-tab-btn"
                  :class="{ active: activeTrendTab === 'alertTrend' }"
                  @click="handleTrendTabChange('alertTrend')">
                  船舶与预警趋势
                </button>
                <span class="trend-tab-separator">|</span>
                <button
                  type="button"
                  class="trend-tab-btn"
                  :class="{ active: activeTrendTab === 'vhfTrend' }"
                  @click="handleTrendTabChange('vhfTrend')">
                  VHF呼叫趋势
                </button>
              </div>
              <div class="data-card-content trend-tab-content">
                <div
                  v-show="activeTrendTab === 'alertTrend'"
                  class="chart-container-mini trend-main-chart"
                  id="alert-trend-chart"
                  v-loading="loading.alertTrend"></div>
                <div
                  v-show="activeTrendTab === 'trafficTrend'"
                  class="chart-container-mini trend-main-chart"
                  id="traffic-trend-chart"
                  v-loading="loading.trafficStats"></div>
                <div
                  v-show="activeTrendTab === 'vhfTrend'"
                  class="chart-container-mini trend-main-chart"
                  id="vhf-trend-chart"
                  v-loading="loading.vhfTrend"></div>
              </div>
            </div>
          </div>

          <div class="panel-right">
            <div class="data-card">
              <div class="data-card-header">预警状态占比</div>
              <div class="data-card-content">
                <div class="chart-container-mini" id="alert-status-chart" v-loading="loading.alertStatus"></div>
              </div>
            </div>

            <div class="data-card">
              <div class="data-card-header">设备状态</div>
              <div class="data-card-content">
                <div class="chart-container-mini" id="device-status" v-loading="loading.deviceStatus"></div>
              </div>
            </div>

            <div class="data-card monitor-tab-card">
              <div class="trend-tab-header">
                <button
                  type="button"
                  class="trend-tab-btn"
                  :class="{ active: activeMonitorTab === 'pass' }"
                  @click="handleMonitorTabChange('pass')">
                  实时通航列表
                </button>
                <span class="trend-tab-separator">|</span>
                <button
                  type="button"
                  class="trend-tab-btn"
                  :class="{ active: activeMonitorTab === 'device' }"
                  @click="handleMonitorTabChange('device')">
                  设备在线监测
                </button>
                <span class="trend-tab-separator">|</span>
                <button
                  type="button"
                  class="trend-tab-btn"
                  :class="{ active: activeMonitorTab === 'unhandled' }"
                  @click="handleMonitorTabChange('unhandled')">
                  未处理预警
                </button>
              </div>
              <div class="data-card-content trend-tab-content">
                <div v-show="activeMonitorTab === 'unhandled'" class="alert-scroll-list" v-loading="loading.unhandledAlert">
                  <div v-if="unhandledAlerts.length > 0" class="alert-scroll-inner">
                    <div
                      v-for="item in unhandledAlerts"
                      :key="item.id"
                      class="alert-scroll-item"
                      :style="{ borderLeftColor: item.color }"
                    >
                      <span class="alert-scroll-name" :title="item.content">{{ item.content }}</span>
                      <span class="alert-scroll-meta">
                        <span class="alert-scroll-time">{{ item.time }}</span>
                        <span class="alert-scroll-type" :style="{ color: item.color }">{{ item.ruleTypeLabel }}</span>
                      </span>
                    </div>
                  </div>
                  <div v-else class="no-data">暂无未处理预警</div>
                </div>

                <div v-show="activeMonitorTab === 'device'" class="device-monitor-list" v-loading="loading.deviceMonitor">
                  <div v-if="deviceRealtimeData.length > 0">
                    <div class="device-item" v-for="dev in deviceRealtimeData" :key="dev.name + dev.type" :class="{ 'offline': dev.status === 'offline' }">
                      <span class="device-status-dot" :class="dev.status"></span>
                      <span class="device-icon">
                        <i :class="dev.icon || 'el-icon-cpu'"></i>
                      </span>
                      <span class="device-name" :title="dev.name">{{ dev.name }}</span>
                      <span class="device-value">
                        {{ dev.value }}<span v-if="dev.extra" class="device-extra"> {{ dev.extra }}</span>
                      </span>
                    </div>
                  </div>
                  <div v-else class="no-data">暂无设备数据</div>
                </div>

                <div v-show="activeMonitorTab === 'pass'" class="alert-scroll-list" v-loading="loading.realtimePass">
                  <div v-if="realtimePassList.length > 0" class="alert-scroll-inner">
                    <div
                      v-for="(item, index) in realtimePassList"
                      :key="`${item.mmsi}-${item.time}-${index}`"
                      class="alert-scroll-item"
                      style="border-left-color: #4fc3f7;"
                    >
                      <span class="alert-scroll-name" :title="item.name">{{ item.name }}</span>
                      <span class="alert-scroll-meta">
                        <span class="alert-scroll-time">{{ item.time }}</span>
                        <span class="alert-scroll-type" style="color: #4fc3f7;">{{ item.direction }}</span>
                        <span class="alert-scroll-type" style="color: #ffc107;">{{ item.speed }}</span>
                      </span>
                    </div>
                  </div>
                  <div v-else class="no-data">暂无通航数据</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getAlertTypeStats, getTrafficStats, getDeviceStats, getVesselTypeStats, getAlertStats, getLatestAlerts, getWeatherData } from '@/api/visualization'
import { getAlertStatisticsByLevel, getAlertStatisticsByStatus, getAlertStatisticsByTime, getUnhandledAlertRecords, getAlertStatisticsByType } from '@/api/alert-record'
import { getBridgeDailyStatistics } from '@/api/account-statistics'
import { getWaterLevelRealTimeData, getVisibilityRealTimeData, getAnemometerRealTimeData, getLaserRealTimeData } from '@/api/device-realtime'
import { getBridgeCrossingRecords, getComprehensiveAlertStatistics, getVhfStatistics } from '@/api/comprehensive-query'

export default {
  name: 'DataVisualization',
  data() {
    return {
      isFullscreen: false,
      bridgeId: null, // 桥梁 ID
      bridgeName: '', // 桥梁名称
      currentTime: '', // 当前时间
      timeTimer: null, // 时间刷新定时器

      // === 新增：左侧面板数据 ===
      // 今日通航统计
      todayTraffic: {
        totalCount: 0,
        upstreamCount: 0,
        downstreamCount: 0,
        byType: [] // [{type: '货船', count: 82}, ...]
      },
      // 告警类型分布（替代告警级别分布）
      alertTypeDistribution: [], // [{type: '偏航预警', count: 10, color: '#ff5722'}, ...]
      // 预警状态分布
      alertStatusDistribution: [], // [{status: '未处理', count: 5}, ...]
      // 船舶类型分布
      vesselTypeDistribution: [],

      // === 新增：中央面板数据 ===
      // 实时通航列表
      realtimePassList: [], // [{time: '14:32', name: '长江 1 号', mmsi: '413829***', direction: '下行', speed: '8.5'}]
      // 未处理告警
      unhandledAlerts: [], // [{id: 1, level: '严重', time: '14:30', content: '...'}]

      // === 新增：右侧面板数据 ===
      // 设备在线监测
      deviceRealtimeData: [], // [{name: '水位计#1', status: 'online', value: '5.2m'}, ...]
      // 近 7 天告警趋势
      alertTrendData: {
        dates: [], // ['03-22', '03-23', ...]
        values: [] // [5, 8, ...]
      },
      // 预警趋势按小时原始缓存（用于按天聚合）
      alertTrendHourlyCache: [],
      // VHF 趋势数据
      vhfTrendData: { dates: [], values: [], uniqueVessels: [] },
      vhfTrendHourlyCache: [],
      // 24 小时流量趋势
      trafficTrendData: {
        dates: [], // ['00:00', '01:00', ...]
        values: [] // [12, 15, ...]
      },

      loading: {
        alertInfo: true, // 告警信息加载状态
        trafficStats: true, // 流量统计加载状态
        deviceStatus: true, // 设备状态加载状态
        shipStats: true, // 船舶统计加载状态
        alertStats: true, // 预警统计加载状态
        realtimeAlerts: true, // 实时预警信息加载状态
        weatherData: true, // 水文气象数据加载状态
        // 新增加载状态
        todayTraffic: true,
        alertType: true,
        alertStatus: true,
        realtimePass: true,
        unhandledAlert: true,
        deviceMonitor: true,
        alertTrend: true,
        vhfTrend: true,
        alertOverview: true
      },

      // 预警统计数据
      todayAlertCount: 0,
      monthlyAlertCount: 0,
      yearlyAlertCount: 0,

      // 今日预警分类配置（已注释，暂不使用）
      yawAlertConfig: {
        number: [0],
        content: '{nt}',
        style: {
          fontSize: 24,
          fill: '#ff5722'
        }
      },
      superelevationAlertConfig: {
        number: [0],
        content: '{nt}',
        style: {
          fontSize: 24,
          fill: '#ff9800'
        }
      },
      overspeedAlertConfig: {
        number: [0],
        content: '{nt}',
        style: {
          fontSize: 24,
          fill: '#ffc107'
        }
      },
      retentionAlertConfig: {
        number: [0],
        content: '{nt}',
        style: {
          fontSize: 24,
          fill: '#4caf50'
        }
      },

      // 实时预警信息
      realtimeAlerts: [],
      // 大屏静默刷新：每 60s 串行请求；趋势/监测仅当前选中 tab 参与（隐藏 tab 不请求）
      dashboardSilentRefreshTimer: null,
      dashboardSilentRefreshInFlight: false,

      // 水文气象数据
      weatherData: {
        waterLevel: { value: '--', unit: 'm' },        // 水位/净空高
        visibility: { value: '--', unit: 'km' },       // 能见度
        windSpeed: { value: '--', unit: 'm/s' },       // 风速
        windDirection: { value: '--', unit: '' }       // 风向
      },

      // ECharts 图表实例
      alertTypeChartInstance: null,
      alertStatusChartInstance: null,
      vesselTypeChartInstance: null,
      alertTrendChartInstance: null,
      trafficTrendChartInstance: null,
      deviceStatusChartInstance: null,
      vhfTrendChartInstance: null,

      // 实时通航列表配置
      realtimePassConfig: {
        data: [],
        carousel: 'single',
        waitTime: 3000,
        rowNum: 5
      },

      // 未处理告警配置
      unhandledAlertConfig: {
        data: [],
        carousel: 'single',
        waitTime: 2000,
        rowNum: 4
      },
      activeTrendTab: 'trafficTrend',
      activeMonitorTab: 'pass',
      // 各趋势/监测 tab 是否已成功拉取过至少一次（未拉过则切 tab 时立即请求，已拉过则只展示缓存等静默更新）
      trendTabFetchedOnce: {
        trafficTrend: false,
        alertTrend: false,
        vhfTrend: false
      },
      monitorTabFetchedOnce: {
        pass: false,
        device: false,
        unhandled: false
      }
    }
  },
  mounted() {
    // 从 localStorage 读取桥梁信息
    this.loadBridgeInfo()

    // 初始化当前时间
    this.updateCurrentTime()
    // 启动时间定时器（仅用于时钟显示）
    this.timeTimer = setInterval(() => {
      this.updateCurrentTime()
    }, 1000)

    this.$nextTick(async () => {
      // 先挂载图表容器，再并行拉首屏（仅当前 tab + 公共模块），最后启动每分钟串行静默刷新
      this.initExtraCharts()
      await this.loadDashboardInitialParallel()
      this.startSilentRefreshTimer()
    })

    // 添加全屏状态变化监听器
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange)
    document.addEventListener('msfullscreenchange', this.handleFullscreenChange)
  },

  beforeDestroy() {
    // 清理时间定时器
    if (this.timeTimer) {
      clearInterval(this.timeTimer)
      this.timeTimer = null
    }
    this.clearSilentRefreshTimer()

    // 移除事件监听器
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange)
    document.removeEventListener('msfullscreenchange', this.handleFullscreenChange)
  },
  computed: {
    todayAlertRate() {
      if (!this.todayTraffic.totalCount) return '0.00%'
      return `${((this.todayAlertCount / this.todayTraffic.totalCount) * 100).toFixed(2)}%`
    },
    peakAlertTimeLabel() {
      if (!this.alertTrendHourlyCache.length) return '--'
      const sorted = [...this.alertTrendHourlyCache].sort((a, b) => (b.value || 0) - (a.value || 0))
      const peak = sorted[0]
      return peak?.timeLabel || peak?.time || '--'
    },
    alertCompareRatio() {
      if (!this.monthlyAlertCount) return '0%'
      const avgDaily = this.monthlyAlertCount / 30
      if (!avgDaily) return '0%'
      const ratio = ((this.todayAlertCount - avgDaily) / avgDaily) * 100
      const sign = ratio > 0 ? '+' : ''
      return `${sign}${ratio.toFixed(1)}%`
    }
  },
  methods: {
    /**
     * 切换趋势 tab：从未请求过的 tab 立即拉一次；已请求过的只展示内存中上次数据，后续靠每分钟静默刷新当前 tab。
     */
    async handleTrendTabChange(tab) {
      if (this.activeTrendTab === tab) {
        this.$nextTick(() => this._resizeTrendCharts(tab))
        return
      }
      this.activeTrendTab = tab
      if (!this.trendTabFetchedOnce[tab]) {
        try {
          if (tab === 'trafficTrend') {
            await this.loadTrafficTrend()
          } else if (tab === 'alertTrend') {
            await this.loadAlertTrend()
          } else if (tab === 'vhfTrend') {
            await this.loadVhfTrend()
          }
        } catch (e) {
          console.error('趋势 tab 首次加载失败:', e)
        }
      }
      this.$nextTick(() => this._resizeTrendCharts(tab))
    },
    _resizeTrendCharts(tab) {
      if (tab === 'alertTrend' && this.alertTrendChartInstance) this.alertTrendChartInstance.resize()
      if (tab === 'trafficTrend' && this.trafficTrendChartInstance) this.trafficTrendChartInstance.resize()
      if (tab === 'vhfTrend' && this.vhfTrendChartInstance) this.vhfTrendChartInstance.resize()
    },
    /**
     * 切换监测 tab：从未请求过的 tab 立即拉一次；已请求过的只展示上次数据，后续靠每分钟静默刷新当前 tab。
     */
    async handleMonitorTabChange(tab) {
      if (this.activeMonitorTab === tab) return
      this.activeMonitorTab = tab
      if (!this.monitorTabFetchedOnce[tab]) {
        try {
          if (tab === 'pass') {
            await this.loadRealtimePassList()
          } else if (tab === 'device') {
            await this.loadDeviceMonitoring()
          } else if (tab === 'unhandled') {
            await this.loadUnhandledAlerts()
          }
        } catch (e) {
          console.error('监测 tab 首次加载失败:', e)
        }
      }
    },
    // 从 localStorage 加载桥梁信息
    loadBridgeInfo() {
      try {
        const selectedBridge = localStorage.getItem('selectedBridge')
        if (selectedBridge) {
          const bridgeInfo = JSON.parse(selectedBridge)
          this.bridgeId = bridgeInfo.id
          this.bridgeName = bridgeInfo.name || '未知桥梁'
        } else {
          this.bridgeId = '227'
          this.bridgeName = '未知桥梁'
        }
      } catch (error) {
        console.error('解析桥梁信息失败:', error)
        this.bridgeId = '227' // 使用默认桥梁 ID
        this.bridgeName = '未知桥梁'
      }
    },

    // 更新当前时间
    updateCurrentTime() {
      const now = new Date()
      const hours = now.getHours().toString().padStart(2, '0')
      const minutes = now.getMinutes().toString().padStart(2, '0')
      const seconds = now.getSeconds().toString().padStart(2, '0')
      this.currentTime = `${hours}:${minutes}:${seconds}`
    },

    // 切换全屏状态
    toggleFullscreen() {
      if (!document.fullscreenElement) {
        // 进入全屏
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen()
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen()
        } else if (document.documentElement.msRequestFullscreen) {
          document.documentElement.msRequestFullscreen()
        }
        this.isFullscreen = true
      } else {
        // 退出全屏
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
        this.isFullscreen = false
      }
    },

    // 监听全屏状态变化
    handleFullscreenChange() {
      this.isFullscreen = !!document.fullscreenElement ||
                          !!document.webkitFullscreenElement ||
                          !!document.msFullscreenElement
    },

    async loadAlertStats(silent = false) {
      if (!silent) this.loading.alertStats = true
      try {
        const response = await getAlertStats(this.bridgeId)
        if (response.code === 200 && response.data) {
          this.todayAlertCount = response.data.todayCount || 0
          this.monthlyAlertCount = response.data.thisMonthCount || 0
          this.yearlyAlertCount = response.data.thisYearCount || 0
        }
      } catch (error) {
        console.error('加载预警统计数据失败:', error)
      } finally {
        if (!silent) this.loading.alertStats = false
      }
    },
    async initDeviceStatus(silent = false) {
      if (!silent) this.loading.deviceStatus = true
      // 先初始化空图表（仅首次）
      if (!this.deviceStatusChartInstance) {
        const el = document.getElementById('device-status')
        if (!el) {
          if (!silent) this.loading.deviceStatus = false
          return
        }
        const chart = this.$echarts.init(el)
        this.deviceStatusChartInstance = chart
        chart.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item',
            formatter: function(params) { return `${params.name}<br/>数量：${params.value}台` },
            backgroundColor: 'rgba(0,0,0,0.8)',
            borderColor: '#4fc3f7',
            textStyle: { color: '#fff' }
          },
          legend: {
            orient: 'horizontal',
            top: '5%',
            left: 'center',
            textStyle: { color: '#fff', fontSize: 12 },
            itemWidth: 12,
            itemHeight: 8,
            itemGap: 15
          },
          series: [{
            name: '设备状态',
            type: 'pie',
            radius: ['35%', '60%'],
            center: ['50%', '60%'],
            data: [],
            label: { show: false },
            emphasis: { itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: 'rgba(0,0,0,0.5)' } }
          }]
        })
        window.addEventListener('resize', () => chart.resize())
      }
      try {
        const response = await getDeviceStats(this.bridgeId)
        if (response.code === 200 && response.data) {
          const deviceData = response.data
          const chartData = []
          if (deviceData.onlineCount >= 0) chartData.push({ value: deviceData.onlineCount, name: '在线', itemStyle: { color: '#4caf50' } })
          if (deviceData.offlineCount >= 0) chartData.push({ value: deviceData.offlineCount, name: '离线', itemStyle: { color: '#f44336' } })
          if (chartData.length === 0) chartData.push({ value: 1, name: '无设备', itemStyle: { color: '#666' } })
          if (this.deviceStatusChartInstance) {
            this.deviceStatusChartInstance.setOption({ series: [{ data: chartData }] })
          }
        }
      } catch (error) {
        console.error('加载设备状态图表失败:', error)
      } finally {
        if (!silent) this.loading.deviceStatus = false
      }
    },
    async loadRealtimeAlerts(silent = false) {
      if (!silent) this.loading.realtimeAlerts = true
      try {
        const response = await getLatestAlerts(this.bridgeId)
        if (response.code === 200 && response.data) {
          // 处理 API 返回的数据格式
          this.realtimeAlerts = response.data.map(item => {
            // 格式化时间显示（API 返回格式：2025-08-27 05:11:34）
            const time = item.alertTime ? this.formatAlertTimeFromString(item.alertTime) : '未知时间'

            // 映射预警类型（根据完整的告警类型列表）
            const typeMapping = {
              'YAW': { type: 'yaw', typeText: '偏航预警' },
              'DEVIATION': { type: 'deviation', typeText: '偏离预警' },
              'SPEED': { type: 'speed', typeText: '速度预警' },
              'OVERSPEED': { type: 'overspeed', typeText: '超速预警' },
              'HEIGHT': { type: 'height', typeText: '高度预警' },
              'OVERHEIGHT': { type: 'overheight', typeText: '超高预警' },
              'STAY': { type: 'stay', typeText: '滞留预警' },
              'BLACKLIST': { type: 'blacklist', typeText: '黑名单预警' }
            }

            const alertTypeInfo = typeMapping[item.ruleType] || { type: 'other', typeText: '其他预警' }

            return {
              id: item.id,
              time: time,
              type: alertTypeInfo.type,
              typeText: alertTypeInfo.typeText,
              message: item.alertMessage || item.sourceData || '预警信息详情',
              level: item.alertLevel,
              ruleName: item.ruleName
            }
          })

          console.log('实时预警信息加载成功:', this.realtimeAlerts.length, '条')
        } else {
          console.warn('获取实时预警信息失败:', response.message)
          this.realtimeAlerts = []
        }
      } catch (error) {
        console.error('加载实时预警信息失败:', error)
        this.realtimeAlerts = []
      } finally {
        if (!silent) this.loading.realtimeAlerts = false
      }
    },

    // 格式化预警时间显示（处理数组格式）
    formatAlertTime(timeStr) {
      try {
        const date = new Date(timeStr)
        if (isNaN(date.getTime())) {
          return timeStr
        }

        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        const seconds = date.getSeconds().toString().padStart(2, '0')

        return `${hours}:${minutes}:${seconds}`
      } catch (error) {
        console.error('时间格式化失败:', error)
        return timeStr
      }
    },

    // 格式化告警时间显示（处理字符串格式：2025-08-27 05:11:34）
    formatAlertTimeFromString(timeStr) {
      try {
        if (!timeStr) return '未知时间'

        // 解析时间字符串
        const date = new Date(timeStr)
        if (isNaN(date.getTime())) {
          // 如果解析失败，尝试直接提取时分秒
          const timeMatch = timeStr.match(/(\d{2}):(\d{2}):(\d{2})/)
          if (timeMatch) {
            return `${timeMatch[1]}:${timeMatch[2]}:${timeMatch[3]}`
          }
          return timeStr
        }

        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        const seconds = date.getSeconds().toString().padStart(2, '0')

        return `${hours}:${minutes}:${seconds}`
      } catch (error) {
        console.error('告警时间格式化失败:', error)
        return timeStr || '未知时间'
      }
    },

    async loadWeatherData(silent = false) {
      if (!silent) this.loading.weatherData = true
      try {
        const response = await getWeatherData(this.bridgeId)
        if (response.code === 200 && response.data) {
          const data = response.data

          // 处理水位数据（净空高）
          if (data.waterLevelData && data.waterLevelData.length > 0) {
            const waterLevel = data.waterLevelData[0]
            const value = this.formatWeatherValue(waterLevel.realTimeValue)
            this.weatherData.waterLevel = { value, unit: 'm' }
          } else {
            this.weatherData.waterLevel = { value: '--', unit: 'm' }
          }

          // 处理能见度数据
          if (data.visibilityData && data.visibilityData.length > 0) {
            const visibility = data.visibilityData[0]
            let value = this.formatWeatherValue(visibility.realTimeValue)
            if (value !== '--') {
              // 转换为公里显示，保留 1 位小数
              value = (parseFloat(value) / 1000).toFixed(1)
            }
            this.weatherData.visibility = { value, unit: 'km' }
          } else {
            this.weatherData.visibility = { value: '--', unit: 'km' }
          }

          // 处理风速风向数据
          if (data.anemometerData && data.anemometerData.length > 0) {
            const anemometer = data.anemometerData[0]
            const realTimeValue = anemometer.realTimeValue

            if (realTimeValue && realTimeValue.status !== 'offline') {
              // 风速
              const windSpeed = this.formatWeatherValue(realTimeValue.windSpeed)
              this.weatherData.windSpeed = { value: windSpeed, unit: 'm/s' }

              // 风向
              const windDirection = this.calculateWindDirection(realTimeValue.windDirection)
              this.weatherData.windDirection = { value: windDirection, unit: '' }
            } else {
              // 设备离线
              this.weatherData.windSpeed = { value: '--', unit: 'm/s' }
              this.weatherData.windDirection = { value: '--', unit: '' }
            }
          } else {
            this.weatherData.windSpeed = { value: '--', unit: 'm/s' }
            this.weatherData.windDirection = { value: '--', unit: '' }
          }

          console.log('水文气象数据加载成功:', this.weatherData)
        } else {
          console.warn('获取水文气象数据失败:', response.message)
          this.setDefaultWeatherData()
        }
      } catch (error) {
        console.error('加载水文气象数据失败:', error)
        this.setDefaultWeatherData()
      } finally {
        if (!silent) this.loading.weatherData = false
      }
    },

    // 设置默认水文气象数据
    setDefaultWeatherData() {
      this.weatherData = {
        waterLevel: { value: '--', unit: 'm' },
        visibility: { value: '--', unit: 'km' },
        windSpeed: { value: '--', unit: 'm/s' },
        windDirection: { value: '--', unit: '' }
      }
    },

    // 格式化气象数值（保留 1 位小数）
    formatWeatherValue(value) {
      if (value === null || value === undefined || value === '' || isNaN(value)) {
        return '--'
      }
      return parseFloat(value).toFixed(1)
    },

    // 根据度数计算风向
    calculateWindDirection(degrees) {
      if (degrees === null || degrees === undefined || isNaN(degrees)) {
        return '--'
      }

      // 风向映射表（以正北为 0 度，顺时针）
      const directions = [
        { min: 0, max: 11.25, name: '北' },
        { min: 11.25, max: 33.75, name: '北东' },
        { min: 33.75, max: 56.25, name: '东北' },
        { min: 56.25, max: 78.75, name: '东' },
        { min: 78.75, max: 101.25, name: '东' },
        { min: 101.25, max: 123.75, name: '东南' },
        { min: 123.75, max: 146.25, name: '东南' },
        { min: 146.25, max: 168.75, name: '南东' },
        { min: 168.75, max: 191.25, name: '南' },
        { min: 191.25, max: 213.75, name: '南西' },
        { min: 213.75, max: 236.25, name: '西南' },
        { min: 236.25, max: 258.75, name: '西' },
        { min: 258.75, max: 281.25, name: '西' },
        { min: 281.25, max: 303.75, name: '西北' },
        { min: 303.75, max: 326.25, name: '西北' },
        { min: 326.25, max: 348.75, name: '北西' },
        { min: 348.75, max: 360, name: '北' }
      ]

      // 标准化角度到 0-360 度范围
      let normalizedDegrees = degrees % 360
      if (normalizedDegrees < 0) {
        normalizedDegrees += 360
      }

      // 查找对应的风向
      for (const direction of directions) {
        if (normalizedDegrees >= direction.min && normalizedDegrees < direction.max) {
          return direction.name
        }
      }

      return '北' // 默认返回北方
    },

    // === 定时器与整盘数据加载 ===
    /**
     * 按批执行异步任务，每批最多 concurrent 个并行（避免 thunk 提前执行，控制首屏并发）
     */
    async runTaskThunksInBatches(thunks, concurrent = 2) {
      for (let i = 0; i < thunks.length; i += concurrent) {
        await Promise.all(thunks.slice(i, i + concurrent).map(fn => fn()))
      }
    },
    /**
     * 首屏拉取：公共模块 + 当前选中的趋势 tab、监测 tab（与静默刷新口径一致，隐藏 tab 不请求）。
     * 全部任务串成队列，按批启动，每批最多 2 个请求并发。
     */
    async loadDashboardInitialParallel() {
      try {
        const thunks = [
          () => this.loadTodayTraffic(),
          () => this.loadAlertTypeDistribution(),
          () => this.loadAlertStatusDistribution()
        ]
        if (this.activeMonitorTab === 'pass') {
          thunks.push(() => this.loadRealtimePassList())
        } else if (this.activeMonitorTab === 'device') {
          thunks.push(() => this.loadDeviceMonitoring())
        } else if (this.activeMonitorTab === 'unhandled') {
          thunks.push(() => this.loadUnhandledAlerts())
        }
        if (this.activeTrendTab === 'trafficTrend') {
          thunks.push(() => this.loadTrafficTrend())
        } else if (this.activeTrendTab === 'alertTrend') {
          thunks.push(() => this.loadAlertTrend())
        } else if (this.activeTrendTab === 'vhfTrend') {
          thunks.push(() => this.loadVhfTrend())
        }
        thunks.push(
          () => this.loadAlertStats(),
          () => this.initDeviceStatus(),
          () => this.loadRealtimeAlerts(),
          () => this.loadWeatherData(),
          () => this.loadVesselTypeStats()
        )
        await this.runTaskThunksInBatches(thunks, 2)
      } catch (error) {
        console.error('初始化数据加载失败:', error)
      } finally {
        Object.keys(this.loading).forEach((key) => {
          this.loading[key] = false
        })
      }
    },
    /**
     * 每分钟静默刷新（串行）；仅当前选中的趋势 tab、监测 tab 参与，其余公共模块照常。
     * 若上一轮尚未执行完（含任一 await 进行中），本次定时触发直接 return，不排队叠加。
     */
    async runSilentDashboardRefresh() {
      if (!this.bridgeId || this.dashboardSilentRefreshInFlight) return
      this.dashboardSilentRefreshInFlight = true
      try {
        await this.loadTodayTraffic(true)
        await this.loadAlertTypeDistribution(true)
        await this.loadAlertStatusDistribution(true)
        if (this.activeMonitorTab === 'pass') {
          await this.loadRealtimePassList(true)
        } else if (this.activeMonitorTab === 'device') {
          await this.loadDeviceMonitoring(true)
        } else if (this.activeMonitorTab === 'unhandled') {
          await this.loadUnhandledAlerts(true)
        }
        if (this.activeTrendTab === 'trafficTrend') {
          await this.loadTrafficTrend(true)
        } else if (this.activeTrendTab === 'alertTrend') {
          await this.loadAlertTrend(true)
        } else if (this.activeTrendTab === 'vhfTrend') {
          await this.loadVhfTrend(true)
        }
        await this.loadAlertStats(true)
        await this.initDeviceStatus(true)
        await this.loadRealtimeAlerts(true)
        await this.loadWeatherData(true)
        await this.loadVesselTypeStats(true)
      } catch (error) {
        console.error('大屏静默刷新失败:', error)
      } finally {
        this.dashboardSilentRefreshInFlight = false
      }
    },
    startSilentRefreshTimer() {
      this.clearSilentRefreshTimer()
      this.dashboardSilentRefreshTimer = setInterval(() => {
        // 上一轮未完成则跳过本分钟 tick，避免静默任务重叠
        if (this.dashboardSilentRefreshInFlight) return
        this.runSilentDashboardRefresh()
      }, 60000)
    },
    clearSilentRefreshTimer() {
      if (this.dashboardSilentRefreshTimer) {
        clearInterval(this.dashboardSilentRefreshTimer)
        this.dashboardSilentRefreshTimer = null
      }
    },

    // === 数据加载方法 ===
    // 加载今日通航统计
    async loadTodayTraffic(silent = false) {
      if (!silent) this.loading.todayTraffic = true
      try {
        const response = await getBridgeDailyStatistics(this.bridgeId)
        if (response.code === 200 && response.data) {
          const data = response.data
          // 展示今日各类预警统计数量
          this.todayTraffic = {
            totalCount: data.todayNavigationCount || 0,
            upstreamCount: 0,
            downstreamCount: 0,
            byType: [
              { type: '偏航', count: data.todayDeviationCount || 0 },
              { type: '超高', count: data.todayOverheightCount || 0 },
              { type: '超速', count: data.todayOverspeedCount || 0 },
              { type: '滞留', count: data.todayDetentionCount || 0 },
              { type: '黑名单', count: data.todayBlacklistCount || 0 }
            ].filter(item => item.count > 0)
          }
        }
      } catch (error) {
        console.error('加载今日通航统计失败:', error)
      } finally {
        if (!silent) this.loading.todayTraffic = false
      }
    },

    // 获取今日起止时间字符串
    _getTodayRange() {
      const now = new Date()
      const pad = v => String(v).padStart(2, '0')
      const date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
      return { startTime: `${date} 00:00:00`, endTime: `${date} 23:59:59` }
    },

    // 加载告警类型分布（当日数据）
    async loadAlertTypeDistribution(silent = false) {
      if (!silent) this.loading.alertType = true
      try {
        const response = await getAlertTypeStats(this.bridgeId)
        if (response.code === 200 && response.data) {
          const colorMap = {
            'YAW':       '#ef4444',
            'SPEED':     '#8b5cf6',
            'HIGH':      '#ec4899',
            'STAY':      '#06b6d4',
            'BLACKLIST': '#6b7280',
            'CROSSING':  '#f59e0b',
            'ENTRY':     '#10b981',
            'EXIT':      '#3b82f6'
          }
          this.alertTypeDistribution = response.data
            .filter(item => item.count > 0)
            .map(item => ({
              type: item.alertTypeName || item.alertType,
              count: item.count,
              color: colorMap[item.alertType] || '#4fc3f7'
            }))
          this.updateAlertTypeChart()
        }
      } catch (error) {
        console.error('加载告警类型分布失败:', error)
      } finally {
        if (!silent) this.loading.alertType = false
      }
    },

    // 加载预警状态分布
    async loadAlertStatusDistribution(silent = false) {
      if (!silent) this.loading.alertStatus = true
      try {
        const response = await getAlertStatisticsByStatus(this.bridgeId)
        if (response.code === 200 && response.data) {
          const data = response.data
          const statusMap = {
            '0': { label: '未处理', color: '#f44336' },
            '1': { label: '已处理', color: '#4caf50' },
            '2': { label: '已忽略', color: '#9e9e9e' }
          }
          this.alertStatusDistribution = Object.entries(data)
            .map(([key, count]) => ({
              status: statusMap[String(key)]?.label || `状态${key}`,
              count: Number(count),
              color: statusMap[String(key)]?.color || '#999'
            }))
            .filter(item => item.count > 0)
          this.updateAlertStatusChart()
        }
      } catch (error) {
        console.error('加载预警状态分布失败:', error)
      } finally {
        if (!silent) this.loading.alertStatus = false
      }
    },

    // 加载实时通航列表
    async loadRealtimePassList(silent = false) {
      if (!silent) this.loading.realtimePass = true
      try {
        // 查今日数据，若无则查近 7 天
        const now = new Date()
        const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
        const pad = v => String(v).padStart(2, '0')
        const fmtDT = d => `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
        const response = await getBridgeCrossingRecords({
          bridgeId: this.bridgeId,
          startTime: fmtDT(todayStart),
          endTime: fmtDT(now),
          pageNum: 1,
          pageSize: 10
        })
        if (response.code === 200 && response.data && response.data.list) {
          const list = response.data.list
          this.realtimePassList = list.map(item => ({
            time: this.formatTimeToHM(item.eventTime),
            name: item.vesselName || item.vesselMmsi,
            mmsi: (item.vesselMmsi || '***').substr(0, 3) + '***',
            direction: item.approachDirectionName || (item.approachDirection === 1 ? '上行' : '下行'),
            speed: item.speed ? item.speed.toFixed(1) + 'kn' : '--'
          }))

          // 更新滚动列表配置
          this.realtimePassConfig.data = this.realtimePassList.map((item, index) => ({
            name: item.name,
            value: `${item.time} | ${item.direction} | ${item.speed}`,
            type: index % 2 === 0 ? 'even' : 'odd'
          }))
          this.monitorTabFetchedOnce.pass = true
        }
      } catch (error) {
        console.error('加载实时通航列表失败:', error)
      } finally {
        if (!silent) this.loading.realtimePass = false
      }
    },

    // 加载未处理预警
    async loadUnhandledAlerts(silent = false) {
      if (!silent) this.loading.unhandledAlert = true
      try {
        const response = await getUnhandledAlertRecords(this.bridgeId, null, 10)
        if (response.code === 200 && response.data) {
          const list = response.data
          // 预警级别颜色映射
          const levelColors = {
            'MILD': '#4caf50',
            'NORMAL': '#2196f3',
            'SERIOUS': '#ffc107',
            'SEVERE': '#ff9800',
            'CRITICAL': '#f44336'
          }
          // 规则类型中文映射
          const ruleTypeMap = {
            'YAW': '偏航',
            'DEVIATION': '偏离',
            'SPEED': '超速',
            'OVERSPEED': '超速',
            'HEIGHT': '超高',
            'HIGH': '超高',
            'OVERHEIGHT': '超高',
            'STAY': '滞留',
            'RETENTION': '滞留',
            'BLACKLIST': '黑名单',
            'ENTRY': '进入',
            'EXIT': '离开',
            'CROSSING': '穿越'
          }
          this.unhandledAlerts = list.map(item => ({
            id: item.id,
            level: item.alertLevel,
            levelLabel: this.getAlertLevelLabel(item.alertLevel),
            color: levelColors[item.alertLevel] || '#999',
            time: this.formatTimeToHM(item.alertTime),
            content: item.alertMessage || item.ruleName || '预警详情',
            ruleTypeLabel: ruleTypeMap[String(item.ruleType || '').toUpperCase()] || item.ruleType || '预警'
          }))
          this.monitorTabFetchedOnce.unhandled = true
        }
      } catch (error) {
        console.error('加载未处理预警失败:', error)
      } finally {
        if (!silent) this.loading.unhandledAlert = false
      }
    },

    // 加载设备在线监测
    async loadDeviceMonitoring(silent = false) {
      if (!silent) this.loading.deviceMonitor = true
      try {
        let waterLevel
        let visibility
        let anemometer
        let laser
        if (!silent) {
          ;[waterLevel, visibility, anemometer, laser] = await Promise.all([
            getWaterLevelRealTimeData(this.bridgeId).catch(() => null),
            getVisibilityRealTimeData(this.bridgeId).catch(() => null),
            getAnemometerRealTimeData(this.bridgeId).catch(() => null),
            getLaserRealTimeData(this.bridgeId).catch(() => null)
          ])
        } else {
          waterLevel = await getWaterLevelRealTimeData(this.bridgeId).catch(() => null)
          visibility = await getVisibilityRealTimeData(this.bridgeId).catch(() => null)
          anemometer = await getAnemometerRealTimeData(this.bridgeId).catch(() => null)
          laser = await getLaserRealTimeData(this.bridgeId).catch(() => null)
        }

        const devices = []

        // 水位计
        if (waterLevel?.data?.length > 0) {
          waterLevel.data.forEach(d => {
            const rv = d.realTimeValue
            // 兼容多种字段名：waterLevel / realTimeValue / value / level
            const raw = rv?.waterLevel ?? rv?.realTimeValue ?? rv?.value ?? rv?.level ?? null
            const numVal = raw !== null && raw !== undefined && !isNaN(Number(raw)) ? Number(raw) : null
            devices.push({
              name: d.deviceName || '水位计',
              type: 'waterlevel',
              icon: 'el-icon-arrow-up',
              unit: 'm',
              status: 'online',
              rawValue: numVal,
              value: numVal !== null ? `${numVal.toFixed(2)} m` : '--',
              label: '水位'
            })
          })
        }

        // 能见度仪
        if (visibility?.data?.length > 0) {
          visibility.data.forEach(d => {
            const rv = d.realTimeValue
            const raw = rv?.visibility ?? rv?.value ?? null
            const numVal = raw !== null && !isNaN(Number(raw)) ? Number(raw) : null
            devices.push({
              name: d.deviceName || '能见度仪',
              type: 'visibility',
              icon: 'el-icon-view',
              unit: 'km',
              status: 'online',
              rawValue: numVal,
              value: numVal !== null ? `${(numVal / 1000).toFixed(1)} km` : '--',
              label: '能见度'
            })
          })
        }

        // 风速风向仪
        if (anemometer?.data?.length > 0) {
          anemometer.data.forEach(d => {
            const rv = d.realTimeValue
            const ws = rv?.windSpeed ?? rv?.speed ?? null
            const wd = this.calculateWindDirection(rv?.windDirection ?? rv?.direction ?? null)
            const wsNum = ws !== null && !isNaN(Number(ws)) ? Number(ws) : null
            devices.push({
              name: d.deviceName || '风速风向仪',
              type: 'anemometer',
              icon: 'el-icon-wind-power',
              unit: 'm/s',
              status: 'online',
              rawValue: wsNum,
              value: wsNum !== null ? `${wsNum.toFixed(1)} m/s` : '--',
              extra: wd !== '--' ? wd : '',
              label: '风速'
            })
          })
        }

        // 激光设备（净空高）
        if (laser?.data?.length > 0) {
          laser.data.forEach(d => {
            const rv = d.realTimeValue
            const raw = rv?.distance ?? rv?.clearance ?? rv?.value ?? null
            const numVal = raw !== null && !isNaN(Number(raw)) ? Number(raw) : null
            devices.push({
              name: d.deviceName || '激光测距仪',
              type: 'laser',
              icon: 'el-icon-aim',
              unit: 'm',
              status: 'online',
              rawValue: numVal,
              value: numVal !== null ? `${numVal.toFixed(2)} m` : '--',
              label: '净空高'
            })
          })
        }

        this.deviceRealtimeData = devices
        this.monitorTabFetchedOnce.device = true
      } catch (error) {
        console.error('加载设备在线监测失败:', error)
      } finally {
        if (!silent) this.loading.deviceMonitor = false
      }
    },

    // 加载预警趋势分析（按天，分事件类型分组）
    async loadAlertTrend(silent = false) {
      if (!silent) this.loading.alertTrend = true
      try {
        const now = new Date()
        const endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
        const startDate = new Date(endDate.getTime() - 6 * 24 * 60 * 60 * 1000)
        startDate.setHours(0, 0, 0, 0)

        const formatDT = (d) => {
          const y = d.getFullYear()
          const mo = String(d.getMonth() + 1).padStart(2, '0')
          const day = String(d.getDate()).padStart(2, '0')
          const h = String(d.getHours()).padStart(2, '0')
          const mi = String(d.getMinutes()).padStart(2, '0')
          const s = String(d.getSeconds()).padStart(2, '0')
          return `${y}-${mo}-${day} ${h}:${mi}:${s}`
        }

        const response = await getComprehensiveAlertStatistics({
          bridgeId: this.bridgeId,
          startTime: formatDT(startDate),
          endTime: formatDT(endDate),
          timeGranularity: 'HOUR'
        })

        if (response.code === 200 && response.data) {
          // 缓存原始按小时数据
          this.alertTrendHourlyCache = response.data.timeSeriesData || []
          // 按天聚合（保留事件类型分组）
          this._aggregateAlertTrendByDay()
          this.updateAlertTrendChart()
          this.trendTabFetchedOnce.alertTrend = true
        }
      } catch (error) {
        console.error('加载预警趋势分析失败:', error)
      } finally {
        if (!silent) this.loading.alertTrend = false
      }
    },

    // 将按小时预警数据聚合为按天（保留事件类型分组）
    _aggregateAlertTrendByDay() {
      const hourlyData = this.alertTrendHourlyCache
      if (!hourlyData || hourlyData.length === 0) {
        this.alertTrendData = { dates: [], grouped: {} }
        return
      }

      const dailyMap = new Map()
      hourlyData.forEach(item => {
        let dateStr = null
        if (item.time) {
          const part = item.time.split(' ')[0]
          if (/^\d{4}-\d{2}-\d{2}$/.test(part)) dateStr = part
        }
        if (!dateStr && item.timeLabel) {
          const parts = item.timeLabel.split(' ')
          const year = item.time ? (item.time.match(/^(\d{4})-/) || [])[1] || new Date().getFullYear() : new Date().getFullYear()
          dateStr = `${year}-${parts[0]}`
        }
        if (!dateStr) return

        const eventTypeCounts = item.extraData?.eventTypeCounts || {}
        if (dailyMap.has(dateStr)) {
          const ex = dailyMap.get(dateStr)
          ex.total = (ex.total || 0) + (item.value || 0)
          Object.keys(eventTypeCounts).forEach(k => {
            ex.eventTypeCounts[k] = (ex.eventTypeCounts[k] || 0) + (eventTypeCounts[k] || 0)
          })
        } else {
          dailyMap.set(dateStr, { total: item.value || 0, eventTypeCounts: { ...eventTypeCounts } })
        }
      })

      const sorted = Array.from(dailyMap.entries()).sort((a, b) => a[0].localeCompare(b[0]))
      const dates = sorted.map(([date]) => {
        const d = new Date(date)
        return `${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
      })

      // 收集所有事件类型
      const allTypes = new Set()
      sorted.forEach(([, data]) => Object.keys(data.eventTypeCounts).forEach(k => allTypes.add(k)))

      const grouped = {}
      allTypes.forEach(type => {
        grouped[type] = sorted.map(([, data]) => data.eventTypeCounts[type] || 0)
      })

      this.alertTrendData = { dates, grouped }
    },

    // 加载 24 小时流量趋势
    async loadTrafficTrend(silent = false) {
      if (!silent) this.loading.trafficStats = true
      try {
        const response = await getTrafficStats(this.bridgeId)
        if (response.code === 200 && response.data) {
          const data = response.data
          this.trafficTrendData = {
            dates: data.map(item => `${item.hour}点`),
            values: data.map(item => item.count || 0)
          }

          // 更新流量趋势图表
          this.updateTrafficTrendChart()
          this.trendTabFetchedOnce.trafficTrend = true
        }
      } catch (error) {
        console.error('加载 24 小时流量趋势失败:', error)
      } finally {
        if (!silent) this.loading.trafficStats = false
      }
    },

    // 获取告警级别标签
    getAlertLevelLabel(level) {
      const map = {
        'MILD': '轻微',
        'NORMAL': '一般',
        'SERIOUS': '较重',
        'SEVERE': '严重',
        'CRITICAL': '特别严重'
      }
      return map[level] || level
    },

    // 格式化时间为 HH:MM
    formatTimeToHM(timeStr) {
      try {
        if (!timeStr) return '--:--'
        const date = new Date(timeStr)
        if (isNaN(date.getTime())) return '--:--'
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${hours}:${minutes}`
      } catch (error) {
        return '--:--'
      }
    },

    // 更新预警类型图表
    updateAlertTypeChart() {
      if (!this.alertTypeChartInstance) return
      const items = [...this.alertTypeDistribution].sort((a, b) => a.count - b.count)
      this.alertTypeChartInstance.setOption({
        yAxis: { data: items.map(i => i.type) },
        series: [{
          data: items.map(i => ({
            value: i.count,
            itemStyle: { color: i.color }
          }))
        }]
      })
    },

    // 更新告警状态图表
    updateAlertStatusChart() {
      if (!this.alertStatusChartInstance) return
      const data = this.alertStatusDistribution.map(item => ({
        name: item.status,
        value: item.count,
        itemStyle: { color: item.color }
      }))
      this.alertStatusChartInstance.setOption({
        legend: { data: data.map(d => d.name) },
        series: [{ data }]
      })
    },

    // 更新告警趋势图表（分组柱状图，按事件类型分色，显示数字）
    updateAlertTrendChart() {
      if (!this.alertTrendChartInstance) return
      const { dates = [], grouped = {} } = this.alertTrendData

      // 事件类型配置
      const eventTypeConfig = {
        'YAW':       { name: '偏航',   color: '#ef4444' },
        'SPEED':     { name: '超速',   color: '#8b5cf6' },
        'HIGH':      { name: '超高',   color: '#ec4899' },
        'STAY':      { name: '滞留',   color: '#06b6d4' },
        'BLACKLIST': { name: '黑名单', color: '#6b7280' },
        'CROSSING':  { name: '穿越',   color: '#f59e0b' },
        'ENTRY':     { name: '进入',   color: '#10b981' },
        'EXIT':      { name: '离开',   color: '#3b82f6' }
      }

      const eventTypeOrder = ['ENTRY', 'EXIT', 'CROSSING', 'YAW', 'SPEED', 'HIGH', 'STAY', 'BLACKLIST']
      const types = Object.keys(grouped).sort((a, b) => {
        const ia = eventTypeOrder.indexOf(a), ib = eventTypeOrder.indexOf(b)
        if (ia === -1 && ib === -1) return a.localeCompare(b)
        if (ia === -1) return 1
        if (ib === -1) return -1
        return ia - ib
      })

      const series = types.map(type => ({
        name: eventTypeConfig[type]?.name || type,
        type: 'bar',
        data: grouped[type] || [],
        barMaxWidth: 20,
        itemStyle: {
          color: eventTypeConfig[type]?.color || '#4fc3f7',
          borderRadius: [2, 2, 0, 0]
        },
        label: {
          show: true,
          position: 'top',
          fontSize: 10,
          color: '#fff',
          fontWeight: 'bold',
          formatter: params => params.value > 0 ? params.value : ''
        }
      }))

      const legendData = types.map(t => eventTypeConfig[t]?.name || t)

      this.alertTrendChartInstance.setOption({
        backgroundColor: 'transparent',
        legend: {
          data: legendData,
          bottom: 0,
          textStyle: { color: '#4fc3f7', fontSize: 10 },
          itemWidth: 10,
          itemHeight: 10
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          ...this._chartTooltipBase(),
          formatter(params) {
            let result = params[0].name + '<br/>'
            let total = 0
            params.forEach(p => {
              if (p.value > 0) {
                result += p.marker + p.seriesName + ': ' + p.value + '<br/>'
                total += p.value
              }
            })
            result += '<span style="font-weight:bold">合计: ' + total + '</span>'
            return result
          }
        },
        grid: { top: 30, left: 10, right: 10, bottom: 55, containLabel: true },
        xAxis: {
          type: 'category',
          data: dates,
          axisLabel: { color: '#4fc3f7', fontSize: 10 },
          axisLine: { lineStyle: { color: '#4fc3f7' } },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          minInterval: 1,
          min: 0,
          axisLabel: { color: '#4fc3f7', fontSize: 10, formatter: val => Number.isInteger(val) ? val : '' },
          splitLine: { lineStyle: { color: 'rgba(79,195,247,0.15)', type: 'dashed' } },
          axisLine: { show: false }
        },
        series
      }, true)
    },

    // 更新流量趋势图表
    updateTrafficTrendChart() {
      if (!this.trafficTrendChartInstance) return
      this.trafficTrendChartInstance.setOption({
        xAxis: { data: this.trafficTrendData.dates },
        series: [{ data: this.trafficTrendData.values }]
      })
    },

    // 初始化额外图表
    initExtraCharts() {
      this.initAlertTypeChart()
      this.initAlertStatusChart()
      this.initVesselTypeChart()
      this.initAlertTrendChart()
      this.initTrafficTrendChart()
      this.initVhfTrendChart()
    },

    // 图表通用 tooltip 配置
    _chartTooltipBase() {
      return {
        backgroundColor: 'rgba(0,0,0,0.8)',
        borderColor: '#4fc3f7',
        textStyle: { color: '#fff' }
      }
    },

    // 初始化预警类型图表（横向柱状图）
    initAlertTypeChart() {
      const el = document.getElementById('alert-type-chart')
      if (!el) return
      const chart = this.$echarts.init(el)
      this.alertTypeChartInstance = chart
      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, formatter: params => `${params[0].name}：${params[0].value} 次`, ...this._chartTooltipBase() },
        grid: { top: 8, left: 8, right: 40, bottom: 8, containLabel: true },
        xAxis: {
          type: 'value',
          minInterval: 1,
          axisLabel: { color: '#4fc3f7', fontSize: 10, formatter: v => Number.isInteger(v) ? v : '' },
          splitLine: { lineStyle: { color: 'rgba(79,195,247,0.15)', type: 'dashed' } },
          axisLine: { show: false }
        },
        yAxis: {
          type: 'category',
          data: [],
          axisLabel: { color: '#4fc3f7', fontSize: 11 },
          axisLine: { lineStyle: { color: '#4fc3f7' } },
          axisTick: { show: false }
        },
        series: [{
          type: 'bar',
          data: [],
          barMaxWidth: 16,
          itemStyle: { borderRadius: [0, 3, 3, 0] },
          label: {
            show: true,
            position: 'right',
            fontSize: 11,
            color: '#fff',
            fontWeight: 'bold',
            formatter: params => params.value > 0 ? params.value + '次' : ''
          }
        }]
      })
      window.addEventListener('resize', () => chart.resize())
    },

    // 初始化告警状态图表
    initAlertStatusChart() {
      const el = document.getElementById('alert-status-chart')
      if (!el) return
      const chart = this.$echarts.init(el)
      this.alertStatusChartInstance = chart
      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: { trigger: 'item', formatter: '{b}: {c}条 ({d}%)', ...this._chartTooltipBase() },
        legend: { orient: 'horizontal', bottom: 0, textStyle: { color: '#fff', fontSize: 11 }, itemWidth: 10, itemHeight: 10 },
        series: [{
          type: 'pie',
          radius: ['30%', '58%'],
          center: ['50%', '42%'],
          data: [],
          label: {
            show: true,
            formatter: '{b}\n{c}条',
            fontSize: 11,
            color: '#fff',
            lineHeight: 16
          },
          labelLine: { show: true, length: 8, length2: 6 },
          emphasis: { itemStyle: { shadowBlur: 10, shadowColor: 'rgba(0,0,0,0.5)' } }
        }]
      })
      window.addEventListener('resize', () => chart.resize())
    },

    // 初始化船舶类型图表（使用真实 API 数据）
    initVesselTypeChart() {
      const el = document.getElementById('vessel-type-chart')
      if (!el) return
      const chart = this.$echarts.init(el)
      this.vesselTypeChartInstance = chart
      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: { trigger: 'item', formatter: '{b}: {c}艘 ({d}%)', ...this._chartTooltipBase() },
        legend: { orient: 'horizontal', bottom: 0, textStyle: { color: '#fff', fontSize: 11 }, itemWidth: 10, itemHeight: 10 },
        series: [{
          type: 'pie',
          radius: ['35%', '65%'],
          center: ['50%', '45%'],
          data: [],
          label: { show: false },
          emphasis: { itemStyle: { shadowBlur: 10, shadowColor: 'rgba(0,0,0,0.5)' } }
        }]
      })
      window.addEventListener('resize', () => chart.resize())
    },
    /** 船舶类型分布数据（首屏并行、静默刷新串行中调用） */
    async loadVesselTypeStats(silent = false) {
      const colors = ['#4fc3f7', '#ff9800', '#4caf50', '#e91e63', '#9c27b0', '#ff5722']
      if (!silent) this.loading.shipStats = true
      try {
        const response = await getVesselTypeStats(this.bridgeId)
        if (response.code === 200 && response.data && response.data.length > 0 && this.vesselTypeChartInstance) {
          const data = response.data.map((item, idx) => ({
            name: item.vesselTypeName || `类型${item.vesselType}`,
            value: item.count,
            itemStyle: { color: colors[idx % colors.length] }
          }))
          this.vesselTypeChartInstance.setOption({ series: [{ data }] })
        }
      } catch (error) {
        console.error('加载船舶类型统计失败:', error)
      } finally {
        if (!silent) this.loading.shipStats = false
      }
    },

    // 初始化告警趋势图表（分组堆叠柱状图）
    initAlertTrendChart() {
      const el = document.getElementById('alert-trend-chart')
      if (!el) return
      const chart = this.$echarts.init(el)
      this.alertTrendChartInstance = chart
      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, ...this._chartTooltipBase() },
        legend: { data: [], bottom: 0, textStyle: { color: '#4fc3f7', fontSize: 10 }, itemWidth: 10, itemHeight: 10 },
        grid: { top: 20, left: 30, right: 10, bottom: 55, containLabel: true },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: { color: '#4fc3f7', fontSize: 10 },
          axisLine: { lineStyle: { color: '#4fc3f7' } },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLabel: { color: '#4fc3f7', fontSize: 10 },
          splitLine: { lineStyle: { color: 'rgba(79,195,247,0.15)', type: 'dashed' } },
          axisLine: { show: false }
        },
        series: []
      })
      window.addEventListener('resize', () => chart.resize())
    },

    // 初始化流量趋势图表
    initTrafficTrendChart() {
      const el = document.getElementById('traffic-trend-chart')
      if (!el) return
      const chart = this.$echarts.init(el)
      this.trafficTrendChartInstance = chart
      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: { trigger: 'axis', ...this._chartTooltipBase() },
        grid: { top: 20, left: 30, right: 10, bottom: 30, containLabel: true },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: { color: '#4fc3f7', fontSize: 10, interval: 3 },
          axisLine: { lineStyle: { color: '#4fc3f7' } },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLabel: { color: '#4fc3f7', fontSize: 10 },
          splitLine: { lineStyle: { color: 'rgba(79,195,247,0.15)', type: 'dashed' } },
          axisLine: { show: false }
        },
        series: [{
          type: 'line',
          smooth: true,
          data: [],
          lineStyle: { color: '#4fc3f7', width: 2 },
          itemStyle: { color: '#4fc3f7' },
          symbol: 'none',
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(79,195,247,0.3)' },
              { offset: 1, color: 'rgba(79,195,247,0.02)' }
            ])
          }
        }]
      })
      window.addEventListener('resize', () => chart.resize())
    },

    // 初始化 VHF 趋势图表
    initVhfTrendChart() {
      const el = document.getElementById('vhf-trend-chart')
      if (!el) return
      const chart = this.$echarts.init(el)
      this.vhfTrendChartInstance = chart
      chart.setOption({
        backgroundColor: 'transparent',
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, ...this._chartTooltipBase() },
        grid: { top: 20, left: 10, right: 10, bottom: 25, containLabel: true },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: { color: '#4fc3f7', fontSize: 10, interval: 0 },
          axisLine: { lineStyle: { color: '#4fc3f7' } },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          minInterval: 1,
          min: 0,
          axisLabel: { color: '#4fc3f7', fontSize: 10, formatter: v => Number.isInteger(v) ? v : '' },
          splitLine: { lineStyle: { color: 'rgba(79,195,247,0.15)', type: 'dashed' } },
          axisLine: { show: false }
        },
        series: [{
          name: 'VHF呼叫次数',
          type: 'bar',
          data: [],
          barMaxWidth: 30,
          itemStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(16,185,129,0.9)' },
              { offset: 1, color: 'rgba(16,185,129,0.2)' }
            ]),
            borderRadius: [3, 3, 0, 0]
          },
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#fff',
            fontWeight: 'bold',
            formatter: params => params.value > 0 ? params.value : ''
          }
        }]
      })
      window.addEventListener('resize', () => chart.resize())
    },

    // 加载 VHF 趋势数据（当天按小时）
    async loadVhfTrend(silent = false) {
      if (!silent) this.loading.vhfTrend = true
      try {
        const now = new Date()
        const pad = v => String(v).padStart(2, '0')
        const fmt = d => `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
        const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
        const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)

        const response = await getVhfStatistics({
          bridgeId: this.bridgeId,
          startTime: fmt(todayStart),
          endTime: fmt(todayEnd),
          timeGranularity: 'HOUR'
        })

        if (response.code === 200 && response.data) {
          const timeSeriesData = (response.data.timeSeriesData || []).sort((a, b) => {
            return new Date(a.time).getTime() - new Date(b.time).getTime()
          })
          this.vhfTrendData = {
            dates: timeSeriesData.map(item => {
              const d = new Date(item.time)
              return `${d.getHours()}`
            }),
            values: timeSeriesData.map(item => item.value || 0),
            uniqueVessels: timeSeriesData.map(item => item.extraData?.uniqueVessels || 0)
          }
          this._updateVhfTrendChart()
          this.trendTabFetchedOnce.vhfTrend = true
        }
      } catch (error) {
        console.error('加载 VHF 趋势失败:', error)
      } finally {
        if (!silent) this.loading.vhfTrend = false
      }
    },

    // 将 VHF 按小时数据聚合为按天
    _aggregateVhfByDay() {
      const hourlyData = this.vhfTrendHourlyCache
      if (!hourlyData || hourlyData.length === 0) {
        this.vhfTrendData = { dates: [], values: [], uniqueVessels: [] }
        return
      }
      const dailyMap = new Map()
      hourlyData.forEach(item => {
        let dateStr = null
        if (item.time) {
          const part = item.time.split(' ')[0]
          if (/^\d{4}-\d{2}-\d{2}$/.test(part)) dateStr = part
        }
        if (!dateStr && item.timeLabel) {
          const year = item.time ? (item.time.match(/^(\d{4})-/) || [])[1] || new Date().getFullYear() : new Date().getFullYear()
          dateStr = `${year}-${item.timeLabel.split(' ')[0]}`
        }
        if (!dateStr) return
        const value = item.value || 0
        const uniqueVessels = item.extraData?.uniqueVessels || 0
        if (dailyMap.has(dateStr)) {
          const ex = dailyMap.get(dateStr)
          ex.value += value
          ex.uniqueVessels += uniqueVessels
        } else {
          dailyMap.set(dateStr, { value, uniqueVessels })
        }
      })
      const sorted = Array.from(dailyMap.entries()).sort((a, b) => a[0].localeCompare(b[0]))
      this.vhfTrendData = {
        dates: sorted.map(([date]) => {
          const d = new Date(date)
          return `${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`
        }),
        values: sorted.map(([, data]) => data.value),
        uniqueVessels: sorted.map(([, data]) => data.uniqueVessels)
      }
    },

    // 更新 VHF 趋势图表
    _updateVhfTrendChart() {
      if (!this.vhfTrendChartInstance) return
      this.vhfTrendChartInstance.setOption({
        xAxis: { data: this.vhfTrendData.dates },
        series: [{ data: this.vhfTrendData.values }]
      })
    },

    // 根据类型获取颜色
    getColorByType(type) {
      const colors = {
        '偏航': '#ff5722',
        '超高': '#ff9800',
        '超速': '#ffc107',
        '滞留': '#4caf50',
        '黑名单': '#f44336'
      }
      return colors[type] || '#4fc3f7'
    },
    getTodayTypeCount(type) {
      const matched = (this.todayTraffic.byType || []).find(item => item.type === type)
      return matched ? matched.count : 0
    }
  }
}
</script>

<style lang="css" src="./DataVisualization.css" scoped></style>
